module.exports = __webpack_public_path__ + "images/emoji/older_man.fe3407eea02d0bb23227.png";